export function moneyDecimals(value: number, decimalPlaces = 2, truncateWholeNumbers = true) {
    if (truncateWholeNumbers && value % 1 === 0) {
        return value.toFixed(0);
    }

    return value.toFixed(decimalPlaces);
}
